module.exports = __webpack_public_path__ + "img/yhmrgx_img.79198c0a.png";